import PropTypes from 'prop-types'

// Heroicons v2 hat keinen 6-Punkte-Grip; Bars3Icon liest sich neben zwei
// Chevrons als "Menue". Deshalb lokal.
const GripIcon = ({ className }) => (
  <svg
    viewBox='0 0 16 16'
    fill='currentColor'
    aria-hidden='true'
    className={className}
  >
    <circle cx='6' cy='4' r='1.5' />
    <circle cx='10' cy='4' r='1.5' />
    <circle cx='6' cy='8' r='1.5' />
    <circle cx='10' cy='8' r='1.5' />
    <circle cx='6' cy='12' r='1.5' />
    <circle cx='10' cy='12' r='1.5' />
  </svg>
)

GripIcon.propTypes = {
  className: PropTypes.string
}

export default GripIcon
